import { ProvinceData, useProvinces } from "@/api/province";
import { useState } from "react";
import { FieldInput } from "@/components/form/field-input";
import { FieldCombobox } from "@/components/form/field-combobox";
import { useFormContext } from "react-hook-form";
import {
  MasterParamData,
  useBranchHpms,
  useFdtAreaHpms,
  useFibernodeAreaHpms,
} from "@/api/master-param";

interface CityFormFieldsProps {
  isDisabled?: boolean;
}

export function CityFormFields({ isDisabled = false }: CityFormFieldsProps) {
  const [provinceSearch, setProvinceSearch] = useState("");
  const [fdtAreaHpmSearch, setFdtAreaHpmSearch] = useState("");
  const [fibernodeAreaHpmSearch, setFibernodeAreaHpmSearch] = useState("");
  const [branchHpmSearch, setBranchHpmSearch] = useState("");

  const { data: provinces } = useProvinces({
    provinceName: provinceSearch,
  });
  const { data: fdtAreaHpms } = useFdtAreaHpms({
    search: fdtAreaHpmSearch,
  });
  const { data: fibernodeAreaHpms } = useFibernodeAreaHpms({
    search: fibernodeAreaHpmSearch,
  });
  const { data: branchHpms } = useBranchHpms({
    search: branchHpmSearch,
  });

  const form = useFormContext();
  const province = form.getValues("province") as ProvinceData;
  const fdtAreaHpm = form.getValues("fdtAreaHpm") as MasterParamData;
  const fibernodeAreaHpm = form.getValues(
    "fibernodeAreaHpm",
  ) as MasterParamData;
  const branchHpm = form.getValues("branchHpm") as MasterParamData;

  const handleKeyDownSpecChar = (
    event: React.KeyboardEvent<HTMLInputElement>,
  ) => {
    if (["-", "@", "#"].includes(event.key)) {
      event.preventDefault();
    }
  };

  return (
    <>
      <FieldInput
        name="cityCode"
        label="City Code"
        isDisabled={isDisabled}
        hasRequiredAsterisk={!isDisabled}
      />
      <FieldInput
        name="cityName"
        label="City Name"
        isDisabled={isDisabled}
        hasRequiredAsterisk={!isDisabled}
      />
      <FieldCombobox
        name="province"
        label="Province Name"
        search={provinceSearch}
        setSearch={setProvinceSearch}
        isDisabled={isDisabled}
        options={(provinces?.content ?? (province && [province]) ?? [])?.map(
          (province) => ({
            value: province,
            label: province.provinceName,
          }),
        )}
        hasRequiredAsterisk={!isDisabled}
      />
      <FieldInput
        name="ftax"
        label="FTAX"
        type="number"
        isDisabled={isDisabled}
        hasRequiredAsterisk={!isDisabled}
        onKeyDown={handleKeyDownSpecChar}
        min={0}
      />
      <FieldCombobox
        name="fdtAreaHpm"
        label="FDT Area HPM"
        search={fdtAreaHpmSearch}
        setSearch={setFdtAreaHpmSearch}
        isDisabled={isDisabled}
        options={(
          fdtAreaHpms?.content ??
          (fdtAreaHpm && [fdtAreaHpm]) ??
          []
        )?.map((fdtAreaHpm) => ({
          value: fdtAreaHpm,
          label: fdtAreaHpm.value,
        }))}
        hasRequiredAsterisk={!isDisabled}
      />
      <FieldCombobox
        name="fibernodeAreaHpm"
        label="FIBERNODE Area HPM"
        search={fibernodeAreaHpmSearch}
        setSearch={setFibernodeAreaHpmSearch}
        isDisabled={isDisabled}
        options={(
          fibernodeAreaHpms?.content ??
          (fibernodeAreaHpm && [fibernodeAreaHpm]) ??
          []
        )?.map((fibernodeAreaHpm) => ({
          value: fibernodeAreaHpm,
          label: fibernodeAreaHpm.value,
        }))}
        hasRequiredAsterisk={!isDisabled}
      />
      <FieldCombobox
        name="branchHpm"
        label="Branch HPM"
        search={branchHpmSearch}
        setSearch={setBranchHpmSearch}
        isDisabled={isDisabled}
        options={(branchHpms?.content ?? (branchHpm && [branchHpm]) ?? [])?.map(
          (branchHpm) => ({
            value: branchHpm,
            label: branchHpm.value,
          }),
        )}
        hasRequiredAsterisk={!isDisabled}
      />
    </>
  );
}
